/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Print_Mode_BlankInputs */

const zh_print_mode_blank = /** @type {(inputs: Print_Mode_BlankInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`空白试卷`)
};

const en_print_mode_blank = /** @type {(inputs: Print_Mode_BlankInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blank Paper`)
};

const es_print_mode_blank = /** @type {(inputs: Print_Mode_BlankInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En blanco`)
};

/**
* | output |
* | --- |
* | "Blank Paper" |
*
* @param {Print_Mode_BlankInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const print_mode_blank = /** @type {((inputs?: Print_Mode_BlankInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Print_Mode_BlankInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_print_mode_blank(inputs)
	if (locale === "en") return en_print_mode_blank(inputs)
	return es_print_mode_blank(inputs)
});